import React from "react";
import ReactTable from "react-table";

const COLUMNS = [
    {
        Header: "Upc",
        accessor: "upc",
        Cell: (row) => {
            const fullUpc = row.original.productModifier ? `${row.value}-${row.original.productModifier}` : row.value;

            return fullUpc;
        },
    },
    {
        Header: "Destinations",
        accessor: "destinations",
        Cell: (row) => {
            return (row.value || []).join(", ");
        },
    },
    {
        Header: "Status",
        accessor: "status",
    },
    {
        Header: "Message",
        accessor: "message",
    },
    {
        Header: "Task Key",
        accessor: "taskContextKey",
    },
];

const SubmitStatus = (props) => {
    return (
        <div>
            <ReactTable data={props.data} columns={COLUMNS} minRows="10" />
        </div>
    );
};

export default SubmitStatus;
